// extracted by mini-css-extract-plugin
module.exports = {"card":"e_TG","bottom":"e_UG","right":"e_VG","rowSeparator":"e_WG","rightLabel":"e_XG","container":"e_YG","top":"e_ZG"};